// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// CareRx patient-scoped reads and writes added after the E-05 freeze of `api/client.ts`.

import { jsonRequest as req } from './http'
import type { ServerPage } from '../components/Pager'

// ── ASP #9: the pharmacy's CareRx patients' languages, looked up by every CareRx table ────────────
export interface CareRxPatientLanguage { patient_id: string; preferred_language: string }
export const listCareRxPatientLanguages = () =>
  req<{ items: CareRxPatientLanguage[] }>('GET', '/carerx/patients/languages')

// ── Enrollment review notes (mig 436): an append-only thread, newest first, paged on the server ──
export interface EnrollmentReviewNote {
  id: string
  review_note: string
  author_name: string | null
  created_at: string
  therapy_id: string | null
}
export const listEnrollmentReviewNotes = (patientId: string, page: number, pageSize: number) =>
  req<ServerPage<EnrollmentReviewNote>>('GET',
    `/carerx/patients/${patientId}/enrollment/review-notes?page=${page}&page_size=${pageSize}`)
export const addEnrollmentReviewNote = (patientId: string, note: string) =>
  req<EnrollmentReviewNote>('POST', `/carerx/patients/${patientId}/enrollment/review-notes`, { note })
